export const planOptions = [
  { value: 'todoRiesgo', label: 'Todo Riesgo Base' },
  { value: 'todoRiesgoFull', label: 'Todo Riesgo Full' },
  { value: 'noDeterminado', label: 'No determinado' },
];

export const DATALAYER_CONFIG = {
  TIPO_ZONA: 'Autos',
  ZONA: 'CaidasLeads',
  SUB_ZONA: {
    INICIO: 'Inicio',
    GRACIAS: 'Gracias',
  },
  SECCION: 'Formulario',
  PARTNER: 'BCP',
  PARTNER_TYPE: 'BCP',
} as const;

export const enum DATALAYER_EVENTS {
  VIRTUAL_PAGE = 'virtualPage',
}

export const enum DATALAYER_EVENT_TYPES {
  PAGEVIEW = 'pageview',
  CLICK = 'click',
}

export const enum DATALAYER_ELEMENT_TYPES {
  PAGE = 'Page',
  BUTTON = 'Botón',
  CHECKBOX = 'Checkbox',
}

export const DATALAYER_VALUES = {
  PAGE_LOAD: 'Page Load',
  PAGES: {
    BCP_ALTERNATIVE: '/seguro-vehicular/leads/bcp-alternative',
    BCP_ALTERNATIVE_THANKS: '/seguro-vehicular/leads/bcp-alternative/gracias',
  },
  PAGE_NAMES: {
    INICIO: 'Seguro Vehicular Leads - Inicio',
    GRACIAS: 'Gracias',
  },
  CLASS_PAGES: {
    INICIO: 'Autos:CaidasLeads:Inicio',
    GRACIAS: 'Autos:CaidasLeads:Gracias',
  },
} as const;

export const enum BUTTON_NAMES {
  ENVIAR = 'Enviar mis datos',
};

export const enum ELEMENT_VALUE  {
  ACCEPT = 'Si',
  REJECT = 'No'
};

export const enum FORM_LABELS  {
  PLACA = 'Placa*',
  DNI = 'DNI o CE*',
  CELULAR = 'Celular*',
  EMAIL = 'Correo electrónico*',
  PLAN = 'Plan a cotizar*',
  REQUIRED_FIELDS = '*Campos obligatorios',
  PLACEHOLDER_PLAN = 'Selecciona un plan'
};

export const enum BUTTON_TEXTS {
  SUBMIT = 'Enviar mis datos',
  SUBMITTING = 'Enviando...'
};

export const enum PAGE_CONTENT  {
  TITLE = 'SEGURO VEHICULAR',
  DESCRIPTION = 'En este momento nuestra página web se encuentra en mantenimiento. Por favor, déjanos tus datos y te contactaremos lo antes posible para ofrecerte el mejor plan para tu vehículo.',
  HELMET_TITLE = 'Inicio',
  HELMET_DESCRIPTION = 'Es la página inicial del formulario',
  TERMS_TEXT = 'Autorizo a Pacífico el tratamiento de mis datos. Conoce más',
  TERMS_LINK_TEXT = 'aquí',
  TERMS_LINK_URL = 'https://www.pacifico.com.pe/terminos-condiciones-ecommerce'
} ;

export const HEADERS_VENTAS_UX = {
  applicationId: 'AUTOS',
  applicationName: 'AUTOS',
  consumerUserId: 'AUTOS',
  consumerServiceName: 'AUTOS',
}